export default "__VITE_PUBLIC_ASSET__ed76dd9a__"